import EditInstructionsPanelInstruction from 'app/src/editor/EditInstructionsPanelInstruction';
import { INSTRUCTIONS_ORDER } from 'app/src/engine/Instruction';
import * as React from 'react';

export default function EditInstructionsPanel(): React.ReactElement {
	return (
		<div className="EditInstructionsPanel">
			<div className="EditInstructionsPanel-innerContainer">
				{INSTRUCTIONS_ORDER.map((instructionType) => (
					<EditInstructionsPanelInstruction
						key={`instruction-${instructionType}`}
						instructionType={instructionType}
					/>
				))}
			</div>
		</div>
	);
}
